<template>
  <div
    v-if="page"
    :class="$style.root"
  >
    <PagesJournalsSlugHeaderComponent :page="page" />

    <div :class="$style.coverImage">
      <CoreImageComponent
        v-if="page?.coverImage?.data?.attributes && page?.showCover !== false"
        :image="page?.coverImage?.data?.attributes"
      />
    </div>

    <CoreBlocksComponent
    :blocks="page?.blocks"
    />

    <SharedRelatedComponent :page="page" />
  </div>
</template>

<script lang="ts" setup>
const props = defineProps<{
  data: object
}>()

const page = baseStrapiGetAttributes(props.data)
</script>

<style module>
.root {
}

.coverImage {
  composes: container from global;
  margin-bottom: calc(var(--unit--vertical) * 2);
}

.coverImage img {
  --base--image--object-fit: contain;
  --base--image--object-position: center;
  --base--image--max-aspect-ratio: 9 / 7;

  display: flex;
  justify-content: center;
}
</style>
